import { Component, OnInit, ChangeDetectorRef, inject, ViewChild, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../commons/services/auth.service';
import { EncryptionDecryptionService } from '../../commons/services/EncryptionDecryption.service';
import { CredentialDTO, User } from '../../commons/class/user.class';
import { AlertService } from '../../commons/components/alert/alert.service';
import { AlertComponent } from '../../commons/components/alert/alert.component';
import { AppModule } from '../../app-module';
import { SessionStorageService } from '../../commons/services/sessionl-storage.service';
import { AltaUsuariosMasivoComponent } from '../altaUsuarioMasiva/altausuariosMasivo.component';
import { EnvioCorreoMasivoComponent } from '../envioCorreoMasivo/envioCorreoMasivo.component';
import { TextualComponent } from 'cjf.sise.web.captcha-lib';

@Component({
  selector: 'oaj-utils-admin',
  templateUrl: 'utilsAdmin.component.html',
  styleUrls: ['utilsAdmin.component.css'],
  imports: [AppModule, AlertComponent, AltaUsuariosMasivoComponent, EnvioCorreoMasivoComponent, TextualComponent],
  providers: [AuthService, EncryptionDecryptionService, AlertService]
})
export class UtilsAdminComponent implements OnInit {

  // Control de vistas
  isAuthenticated = false;
  selectedOption: 'menu' | 'registroMasivo' | 'envioCorreo' = 'menu';
  
  // Formulario de login
  usuario = '';
  password = '';
  loading = false;
  showPassword = false;
  captchaValido = false;
  captchaId = '';
  @ViewChild('captchaComponent') childCaptcha!: TextualComponent;

  private alertService: AlertService = inject(AlertService);
  private authService: AuthService = inject(AuthService);
  private serviceED: EncryptionDecryptionService = inject(EncryptionDecryptionService);
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);
  private router: Router = inject(Router);
  private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private zone: NgZone = inject(NgZone);

  ngOnInit(): void {
    // Verificar si ya existe una sesión activa
    const utilsAdminUser = this.sessionStorageService.getItem<User>('utilsAdminUser');
    
    if (utilsAdminUser && utilsAdminUser.idTypeCourt === 73) {
      this.isAuthenticated = true;
      this.selectedOption = 'menu';
    }
  }

  /**
   * Procesa el login del usuario administrador
   */
  login(): void {
    if (!this.usuario || !this.password) {
      setTimeout(() => {
        this.alertService.warn('Debe ingresar usuario y contraseña', { autoClose: true, keepAfterRouteChange: false });
      }, 0);
      return;
    }

    if (this.password.length < 8) {
      setTimeout(() => {
        this.alertService.warn('La contraseña debe tener al menos 8 caracteres', { autoClose: true, keepAfterRouteChange: false });
      }, 0);
      return;
    }

    if (!this.captchaValido) {
      setTimeout(() => {
        this.alertService.warn('Por favor, valida el captcha', { autoClose: true, keepAfterRouteChange: false });
      }, 0);
      return;
    }

    this.loading = true;

    const passEncrypted = this.serviceED.Encryption(this.password);
    const ipEncrypted = this.serviceED.Encryption('127.0.0.1');
    const captchaEncrypted = this.serviceED.Encryption(this.captchaId);

    const request: CredentialDTO = new CredentialDTO();
    request.User = this.usuario;
    request.Password = passEncrypted;
    request.Ip = ipEncrypted;
    request.idCaptcha = captchaEncrypted;

    this.authService.login(request).subscribe({
      next: (response: any) => {
        this.loading = false;
        if (response.succeeded) {
          // Verificar que sea tipo organismo 73
          if (response.itypeOrg === 73 && response.bAdmin) {
            const usuario: User = new User();
            usuario.id = response.user;
            usuario.userName = response.account;
            usuario.token = response.accessToken;
            usuario.idTypeCourt = response.itypeOrg;
            usuario.TypeCourt = response.typeOrg;
            usuario.isAdmin = response.bAdmin;
            usuario.idAdmin = response.iAdmin;
            usuario.courtAux = response.iOrg;
            usuario.nameCourtAux = response.org;
            usuario.active = response.active;
            usuario.bPermisoAdmin = response.bPermisoAdmin;
            usuario.bSuperAdmin = response.bSuperAdmin;
            usuario.bPermisoNoFirma = response.bPermisoNoFirma;
            usuario.idAutoEnrolamiento = response.idAutoEnrolamiento;
            usuario.cuentaConSupervision = response.cuentaConSupervision;

            this.sessionStorageService.setItem('currentUser', usuario);
            this.isAuthenticated = true;
            this.selectedOption = 'menu';
            this.changeDetectorRef.detectChanges();
           
          } else {
            this.captchaValido = false;           
            setTimeout(() => {
              this.alertService.error('No tiene permisos para acceder a esta sección.', { autoClose: true, keepAfterRouteChange: false });
               this.changeDetectorRef.detectChanges();
            }, 100);
          }
        } else {
          this.captchaValido = false;             
          setTimeout(() => {
            this.alertService.error('Por favor, valida tu usuario y contraseña', { autoClose: true, keepAfterRouteChange: false });
         this.changeDetectorRef.detectChanges(); 
        }, 100);
        }
      },
      error: (error) => {
        console.error('Error login:', error.message);
        this.loading = false;
        this.captchaValido = false;
        setTimeout(() => {
          this.alertService.error('Por favor, valida tu usuario y contraseña', { autoClose: true, keepAfterRouteChange: false });        
        this.changeDetectorRef.detectChanges();
        }, 100);
      }
    });
  }

  /**
   * Cierra la sesión del usuario administrador
   */
  logout(): void {
 this.authService.logout();
    this.zone.run(() => {
      this.router.navigateByUrl('/login');
    });
  }

  /**
   * Selecciona una opción del menú
   */
  selectOption(option: 'registroMasivo' | 'envioCorreo'): void {
    this.selectedOption = option;
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Vuelve al menú principal
   */
  backToMenu(): void {
    this.selectedOption = 'menu';
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Alterna la visibilidad de la contraseña
   */
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  /**
   * Maneja la respuesta del captcha
   */
  respuestaCaptcha(respuesta: boolean): void {
    if (respuesta) {
      this.captchaId = this.childCaptcha.captchaId;
      this.captchaValido = true;
    }
  }
}
